var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"child1",staticStyle:{"margin-top":"20px"}},[_c('div',{staticClass:"rot-img",staticStyle:{"display":"flex","justify-content":"center"}},[_c('img',{staticStyle:{"width":"80px","height":"80px"},attrs:{"src":require("@/assets/reload-icon.png"),"alt":""}})])])
}]

export { render, staticRenderFns }